export const ESG_MATURITY_LEVELS = {
    LAGGARD: {
        label: 'Laggard',
        color: '#FF0000',
        description: 'Initial stage with limited ESG practices and awareness. Basic compliance with minimal voluntary initiatives.',
        frenchLabel: 'Retardataire'
    },
    BEGINNER: {
        label: 'Beginner',
        color: '#FF9900',
        description: 'Basic ESG practices in place. Starting to implement voluntary initiatives and basic reporting.',
        frenchLabel: 'Débutant'
    },
    INTERMEDIATE: {
        label: 'Intermediate',
        color: '#B6D7A8',
        description: 'Well-established ESG practices. Regular reporting and some strategic initiatives in place.',
        frenchLabel: 'Intermédiaire'
    },
    ADVANCED: {
        label: 'Advanced',
        color: '#93C47D',
        description: 'Comprehensive ESG integration. Strong strategic initiatives, detailed reporting, and stakeholder engagement.',
        frenchLabel: 'Avancé'
    },
    LEADER: {
        label: 'Leader',
        color: '#38761D',
        description: 'Industry-leading ESG practices. Innovation, leadership in sustainability, and comprehensive stakeholder value creation.',
        frenchLabel: 'Leader'
    }
}; 